module.exports = __webpack_public_path__ + "static/negative-test-55f0d826aeed863ad41d26f3fca0ca0c.jpeg";